import { useLoaderData, useRouteError } from "react-router-dom";
import GenericErrorDisplay from "../../generic-error";
import "./styles.css";
import { useRef, useState } from "react";
import ResourceDisplay from "../../../components/resource-display";
import ButtonPrimary from "../../../components/button-primary/index";
import Form230Service from "../../../service/form230/index";
import { SyncLoader } from "react-spinners";
import STYLES_CONSTANTS from "../../../styles/index";
import ResourceService from "../../../service/resource";

const resourceKeys = {
  cover: "support-230-cover",
  subtitle: "support-230-subtitle",
  fillTitle: "support-230-fill-title",
  sendTitle: "support-230-send-title",
};

export const path = "form230/";

export async function loader({ request }) {
  return await new ResourceService().read.byIds(Object.values(resourceKeys));
}

export function Component() {
  const resources = useLoaderData();

  const [color, setColor] = useState(null);
  const [resultMessage, setResultMessage] = useState(undefined);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const filesRef = useRef();
  const [gdpr, setGdpr] = useState(false);

  async function handleFormSubmit(e) {
    e.preventDefault();
    setResultMessage(null);

    const response = await new Form230Service().create.upload(
      name,
      email,
      filesRef.current.files[0],
      gdpr
    );
    setColor(response === null ? "green" : "red");
    setResultMessage(
      response ?? `Response recorded. You will be contacted on <${email}>.`
    );
  }

  return (
    <div id="form230">
      <header>
        <ResourceDisplay resource={resources[resourceKeys.cover]} />
        <div
          style={{
            height: "var(--gap-medium)",
            backgroundColor: "var(--color-fasmr-blue)",
          }}
        />
      </header>
      <div className="content content-container">
        <ResourceDisplay
          resource={resources[resourceKeys.subtitle]}
          wrapper="h4"
        />
        <div className="card">
          <ResourceDisplay
            resource={resources[resourceKeys.fillTitle]}
            wrapper="h2"
          />
          <iframe
            title="fill-form"
            src="https://formular230.ro/federatia-asociatiilor-studentilor-in-medicina-din-romania?fbclid=IwAR3JZlPL01kwFwLDdmt6VZuznNSI2QgyNl9E5vGXx2KPAnS4Z9tnnaSdnzQ"
          />
        </div>
        <div className="card send">
          <ResourceDisplay
            resource={resources[resourceKeys.sendTitle]}
            wrapper="h2"
          />
          <form>
            <label for="name">Nume</label>
            <input
              type="text"
              name="name"
              id="form-230-name"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
            <label for="email">E-mail</label>
            <input
              type="text"
              name="email"
              id="form-230-email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <label for="file">Formular</label>
            <input type="file" name="file" id="form-230-file" ref={filesRef} />
            <label for="gdpr">GDPR</label>
            <div>
              <input
                type="checkbox"
                name="gdpr"
                id="form-230-gdpr"
                value={gdpr}
                onChange={(event) => setGdpr(event.target.value)}
              />
              Sunt de acord cu prelucrarea datelor
            </div>
            <div />
            <ButtonPrimary onClick={handleFormSubmit} className="submit">
              Trimite
            </ButtonPrimary>
            <div />
            <div style={{ color }}>
              {resultMessage === null ? (
                <SyncLoader color={STYLES_CONSTANTS["--color-fasmr-blue"]} />
              ) : (
                resultMessage
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
Component.displayName = "page-sustine-230";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-sustine-230-error";
